import "./project.scss";
import moment from "moment";
import { useParams, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "redux/reducers";
import { useStream } from "hooks/stream";
import { ProjectType, RootState } from "types";

function Project({ project, openOptionModal }: { project: ProjectType; openOptionModal: any }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: RootState) => state.user);
    const params = useParams<any>();
    const stream = useStream(project.ProjectSubTypeId);

    const getStreamName = (id: number) => {
        return (
            {
                7: "twitter",
                8: "facebook",
                9: "instagram",
                10: "youtube",
                11: "linkedin",
                12: "tiktok",
            }[id] || ""
        );
    };

    const selectOrDeleteProject = async () => {
        dispatch(actions.project.set(project));
        // history.push(`/client/${params.clientId}/project/${project.Id}?datefrom=${moment().subtract(1, 'day').format("MM-DD-YYYY")}&dateto=${moment().format("MM-DD-YYYY")}&streams=${getStreamIds()}`)
        if (project.StreamId.toString() == "") {
            history.push(`/client/${params.clientId}/project/${project.Id}?datefrom=${moment().subtract(1, "day").format("YYYY-MM-DD")}&dateto=${moment().format("YYYY-MM-DD")}&streams=11`);
        } else {
            history.push(`/client/${params.clientId}/project/${project.Id}?datefrom=${moment().subtract(1, "day").format("YYYY-MM-DD")}&dateto=${moment().format("YYYY-MM-DD")}&streams=${project.StreamId}`);
        }
    };

    return (
        <div className="project-container">
            <div className={`project type-${project.ProjectTypeId}`} onClick={selectOrDeleteProject}>
                <p className="project-heading">{project.Description}</p>
                <i className="fad fa-clipboard-list"></i>
                <p className="project-id">{project.Id}</p>
                <i className={`fab fa-${getStreamName(project.StreamId)}`}></i>
                <p className="project-date">
                    {moment(project.StartDate).format("D MMM YYYY")} - {project.StopDate ? moment(project.StopDate).format("D MMM YYYY") : "not set"}
                </p>
            </div>
            {user.IsAdmin === true && (
                <div className={`options`} onClick={() => openOptionModal(project.Id, project.Description)} title={"delete " + project.Description}>
                    <i className="fa fa-cog delete-icon" aria-hidden="true"></i>
                </div>
            )}
        </div>
    );
}

export default Project;
